import { API_URLS } from "@/constants";
import apiRequest from "@/lib/axios";
import { getRecaptchaToken } from "@/lib/recaptcha";
import { SignInSuccess, SignInUserResponse, TotpSetupStart, User } from "@/types";

export const loginUser = async (data: Partial<User>): Promise<SignInUserResponse> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.AUTH.LOGIN,
    data: { ...data, recaptchaToken: await getRecaptchaToken("login") },
    errorMessage: "Login failed. Please check your credentials and try again.",
  });
};

export const loginAgentFromAdmin = async (
  userId: string,
  code?: string,
): Promise<SignInSuccess | { requires2fa: true }> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.AUTH.ADMINLOGIN,
    data: { userId, ...(code && { code }) },
    errorMessage: "Login failed.",
  });
};

export const verifyLogin2fa = async (data: {
  pendingToken: string;
  code: string;
}): Promise<SignInSuccess> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.AUTH.VERIFY_2FA,
    data,
    errorMessage: "Verification failed. Please check the code and try again.",
  });
};

// Enforced 2FA, first login: the setupToken from login opens only these two calls.
export const startAdmin2faSetup = async (setupToken: string): Promise<TotpSetupStart> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.AUTH.SETUP_2FA_START,
    data: { setupToken },
    errorMessage: "Could not start two-factor setup. Please sign in again.",
  });
};

export const completeAdmin2faSetup = async (data: {
  setupToken: string;
  code: string;
}): Promise<SignInSuccess> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.AUTH.SETUP_2FA_VERIFY,
    data,
    errorMessage: "Verification failed. Please check the code and try again.",
  });
};

export const logoutUser = async (): Promise<void> => {
  await apiRequest({
    method: "POST",
    url: API_URLS.AUTH.LOGOUT,
    errorMessage: "Failed to log out. Please try again.",
  });
};
